import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import utils from '@/shared/utils/adminpulse';

export const imageDataToBase64Url = httpResponse =>
  new Promise((resolve, reject) => {
    const fileType = httpResponse.headers['content-type'] || 'image/png';

    const blob = new Blob([httpResponse.data], {
      type: fileType,
    });
    const reader = new FileReader();
    reader.onload = function onLoad(evt) {
      resolve(evt.target.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const getImageAsBase64Url = (url, intl) =>
  api.base
    .get(url, {
      responseType: 'arraybuffer',
    })
    .then(imageDataToBase64Url)
    .catch(error => {
      const errorObject = utils.arrayBufferToObject(error.response && error.response.data);

      return handleHttpError(intl)(errorObject);
    });
